import { render } from "./GroupCards.vue?vue&type=template&id=639fcb54&scoped=true"
import script from "./GroupCards.vue?vue&type=script&lang=js"
export * from "./GroupCards.vue?vue&type=script&lang=js"

import "./GroupCards.vue?vue&type=style&index=0&id=639fcb54&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639fcb54"]])

export default __exports__